var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "message_panel",
      class: [_vm.arrowDirection == "right" ? "arrow_right" : "arrow_left"],
    },
    [
      _c(
        "div",
        { staticClass: "panel_box" },
        [_vm._t("content"), _c("div", { staticClass: "panel_arrow" })],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }